import type { HelpFile } from '../../types/help'
import { EnforcementObjectsTestIds } from '../../../testids/EnforcementObjectsTestIds'

export const enforcementObjectsHelp: HelpFile = {
  docPage: '/docs/systems/enforcement-objects',
  texts: {
    [EnforcementObjectsTestIds.enforcementObjectsList]:
      'Enforcement objects defined in connected target systems — the concrete access rights an access profile can grant.',
    [EnforcementObjectsTestIds.colExternalId]:
      'The identifier the target system uses for this enforcement object — for example, the LDAP DN, the database role name, or the SCIM group ID. Use this when reconciling against the system of record.',
  },
}
